import React from 'react'
import './linksBox.css'
import LinksBoxItem from './linksBoxItem'

export default function LinksBox({linksBoxIsOpen, handleLinksBox, links}) {
    const apiURL = process.env.REACT_APP_API_URL

    return (
        linksBoxIsOpen && (
            <div className="linksBox">
                <button className="linksBox__close" onClick={() => handleLinksBox(false)}>X</button>
                <div className="linksBox__container">
                    {links.map((link) => {
                        const imageURL = link.attributes.Image.data ? apiURL + link.attributes.Image.data.attributes.url : ''
                        const videoURL = link.attributes.Video.data ? apiURL + link.attributes.Video.data.attributes.url : ''
                        const pdfURL = link.attributes.PDF.data ? apiURL + link.attributes.PDF.data.attributes.url : ''

                        return  <LinksBoxItem 
                                    key={link.id}
                                    url={link.attributes.URL}
                                    image={imageURL}
                                    type={link.attributes.Type}
                                    title={link.attributes.Header}
                                    subheader={link.attributes.Subheader}
                                    video={videoURL}
                                    subtitles={link.attributes.Subtitles}
                                    pdf={pdfURL}
                                />
                    })}
                </div>
            </div>
        )
    )
}